import { render, staticRenderFns } from "./FacturaElectronicaView.vue?vue&type=template&id=df620b12&"
import script from "./FacturaElectronicaView.vue?vue&type=script&lang=js&"
export * from "./FacturaElectronicaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports